<template>
    <v-row v-if="routine" :class="['kimsa-elevation', { 'readonly': readonly }]" :ripple="!readonly" @click="onClick"
        @mouseover="$emit('hover')" @mouseout="$emit('hover-out')">
        <v-col cols="3" class="pa-0">
            <div class="img-routine" :style="{ backgroundImage: `url('${routineImg}')` }" />
        </v-col>
        <v-col cols="9" class="p-relative">
            <div :class="['name-routine text-truncate', { 'name-width': withMenu }]">
                {{ routine.name || routine.versus }}
            </div>
            <div v-if="isCompetence" class="description-routine text-truncate">
                {{ $t('common.competence') }}
            </div>
            <div v-else class="description-routine text-truncate">
                {{ routine.blocks.length }}
                <span class="text-lowercase">{{ $tc(`common.blocks`, 2) }}</span>
            </div>
            <div class="description-routine text-truncate">
                {{ routineDuration }}
            </div>
            <div v-if="studentId" class="description-routine text-truncate">
                {{ $t('routines.assigned_to', { name: studentName }) }}
            </div>
            <v-menu offset-x v-if="withMenu">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="menu-card">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item link @click="editRoutine">
                        <v-list-item-title>
                            {{ $t('routines.edit_routine') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="assignRoutine">
                        <v-list-item-title>
                            {{ $t('routines.assign_routine') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="copyRoutine">
                        <v-list-item-title>
                            {{ $t('routines.copy_routine') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="deleteRoutine">
                        <v-list-item-title>
                            {{ $t('routines.delete_routine') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="saveInFolder" v-if="!noFolder">
                        <v-list-item-title>
                            {{ $t('common.save_in_folder') }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>

import { db, Timestamp } from '@/utils/Firebase'

export default {
    props: {
        routine: {
            type: Object,
            default: null,
        },
        studentId: {
            type: String,
            default: null,
        },
        withMenu: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        noFolder: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            student: null,
            minutes: 0,
        }
    },
    async mounted() {
        const vm = this
        await vm.getStudentData()
        vm.getRoutineMinutes()
    },
    computed: {
        isCompetence(vm = this) {
            return vm.routine?.type === 'competence' || false
        },
        routineImg(vm = this) {
            if (vm.student?.avatar) return vm.student?.avatar
            return vm.routine.img || vm.imgPlaceholder
        },
        routineDuration(vm = this) {
            if (!vm.minutes) return vm.$t('common.not_available_short')
            let minutesString = vm.$tc(`common.minutes`, Number(vm.minutes) === 1 ? 1 : 2).toLowerCase()
            let minutesAdded = Number(vm.minutes * 1.3).toFixed()
            if (Number(vm.minutes) === Number(minutesAdded)) return `${vm.minutes} ${minutesString}`
            return `${vm.minutes} - ${minutesAdded} ${minutesString}`
        },
        studentName(vm = this) {
            return vm.student?.name || '...'
        }
    },
    methods: {
        onClick() {
            const vm = this
            vm.$emit('click')
        },
        editRoutine() {
            const vm = this
            vm.$router.push({ name: 'coach.routines.edit', params: { uid: vm.routine.objectID } })
        },
        assignRoutine() {
            const vm = this
            vm.$emit('assign')
        },
        async copyRoutine() {
            let vm = this
            let routine = vm.routine

            routine.owner = 'user'
            routine.coachId = vm.currentUser.uid
            routine.name = `${routine.name} ${vm.$t('common.copy_template')}`
            delete routine.created_at

            routine = JSON.parse(JSON.stringify(routine))

            let newRoutine = await db.collection('routines').add({ ...routine, created_at: Timestamp.now() })

            await vm.$router.push({ name: 'coach.routines.edit', params: { uid: newRoutine.id } })
        },
        deleteRoutine() {
            const vm = this
            vm.$emit('delete')
        },
        saveInFolder() {
            const vm = this
            vm.$emit('folder')
        },
        async getStudentData() {
            const vm = this
            if (!vm.studentId) return;
            let studentRef = await db.collection('users').doc(vm.studentId).get()
            vm.student = studentRef.data()
        },
        getRoutineMinutes() {
            const vm = this
            let minutes = 0
            vm.routine?.blocks?.forEach(block => {
                block.exercises.forEach(exercise => {
                    minutes += exercise?.config?.sets?.length || block.sets || 0
                })
            })
            vm.minutes = minutes
        }
    },
    watch: {
        studentId() {
            this.getStudentData()
        },
    }
}
</script>

<style scoped>
.name-routine {
    font-size: 15px;
    font-weight: bold;
}

.name-width {
    width: 85%;
}

.description-routine {
    font-size: 13px;
    color: #999999;
}

.img-routine {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.07);
    height: 100%;
}

.readonly {
    pointer-events: none;
}

.menu-card {
    position: absolute;
    right: 12px;
    top: 4px;
}
</style>